module.exports = __webpack_public_path__ + "static/099_chrzan_anagl-1cdf26f4b03a910dbd971e9e2564ae90.jpg";